import React from "react";

interface IntervalPaginatorProps {
  totalItems: number;
  currentStart: number;
  maxInterval: number;
  onIntervalChange: (newStart: number) => void;
}

export const IntervalPaginator: React.FC<IntervalPaginatorProps> = ({
  totalItems,
  currentStart,
  maxInterval,
  onIntervalChange,
}) => {
  const currentEnd = Math.min(currentStart + maxInterval, totalItems);
  const hasNext = currentEnd < totalItems;
  const hasPrevious = currentStart > 0;

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        marginBottom: "8px",
        alignItems: "center",
      }}
    >
      <button
        onClick={() =>
          onIntervalChange(Math.max(0, currentStart - maxInterval))
        }
        disabled={!hasPrevious}
      >
        Previous
      </button>
      <span>
        Showing {currentStart + 1}-{currentEnd} of {totalItems}
      </span>
      <button
        onClick={() => onIntervalChange(currentStart + maxInterval)}
        disabled={!hasNext}
      >
        Next
      </button>
    </div>
  );
};
